// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `body {
  /* font-family:Verdana, Geneva, Tahoma, sans-serif!important; */
  /* font-family: Helvetica Neue,
    Helvetica,
    Arial,
    sans-serif!important;
  text-shadow: 0px .1px 0px rgba(0, 0, 0, 0.65);
  font-size: 13px !important; */
  /*   letter-spacing: .2px;
 */
  background-color: #f6dfda;
  background-size: "contain";
  background-repeat: repeat;
  font-family: "Source Sans 3", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji"}

* {
  font-size: 12px;
}

.svgIv {
  width: 16px !important;
  margin-right: 5px;
}

.faIv {
  font-size: 14px !important;
  margin-right: 5px;
}

.letra-blanca {
  color: white !important;
}

.buscarpacientelist {
  max-height: 350px;
  overflow-y: scroll;
}

.w150 {
  min-width: 150px !important;
}

.row > * {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.row {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.fijopanelleft {
  margin-left: 25% !important;
}

.header-fixed .header {
  position: fixed;
  top: 0;
  right: 0;
  left: 0;
  z-index: 1000;
  height: 10vh;
  transition: all 0.3s ease;
}

a {
  text-decoration: none !important;
  color: #100f0f !important;
  /* font-weight: 600; */
}

.acordionBotonColorText {
  color: rgb(10, 10, 10) !important;
}

.borde-layout {
  box-shadow: -1px 3px 6px 3px rgb(202 212 228);
}

.borde-tarjeta {
  box-shadow: 0px 5px 8px rgb(200, 193, 193);
  background-clip: border-box !important;
  /*  box-shadow: 0 0 7px 0px rgb(187, 188, 191); */
}

.borde-modal {
  box-shadow: 0 12px 28px 0 rgb(202 212 228), 0 2px 4px 0 rgb(202 212 228),
    inset 0 0 0 1px rgb(202 212 228);
}

.borde {
  --T68779821: 0 1px 2px var(--shadow-2);
  --webkit-box-shadow: var(--T68779821);
  box-shadow: 0 1px 2px var(--shadow-2);
}

/*  .borde {
    box-shadow: 3px 3px 9px -6px rgb(89 97 103);
  } */
.zindex {
  z-index: 90 !important;
}

.card {
  border: none !important;
  border-radius: 10px !important;
}

.card {
  position: relative;
  display: flex;
  flex-direction: column;
  min-width: 0;
  word-wrap: break-word;
  background-color: #ffffff;
  background-clip: border-box;
  border: 1px solid #ebedf3;
  border-radius: 0rem;
}

.card-body {
  padding: 12px;
}

.card-header {
  padding: 12px;
  margin-bottom: 0;
  background-color: #f2eeee;
  border-bottom: 1px solid #ebedf3;
  color: #100f0f;
  box-shadow: -1px 3px 6px 1px rgb(202 212 228);
}

.bg-Black {
  background: rgb(42 46 51);
}

.bg-green {
  background: green !important;
  color: white !important;
  margin: 1px;
}

.bg-red {
  background: red !important;
  color: white !important;
  margin: 1px;
}

.bg-integralvet {
  /*background: #2196f3 !important;*/
  background-color: #007ee2;
  border-bottom: "1px solid #d8d8d8";
  color: white;
}

.bordecircular {
  border-radius: 12px;
}

.bordecircularpanel {
  border-radius: 20px;
  /*   min-height: 50%;
 */
}

.modal .modal-header > button {
  border: 1px solid black !important;
  padding: 0px !important;
  border-radius: 45px !important;
  background-color: white;
  color: black;
  width: 30px;
  height: 30px;
}

.modal-content {
  /* padding: 12px; */
  border-radius: 0px;
  box-shadow: 0px 3px 8px rgb(169 164 164 / 68%);
  background-clip: border-box !important;
}

.modal .modal-header .close span {
  display: block !important;
  color: black;
  font-size: 18px !important;
}

.cabeceraNotify {
  padding: 0.5rem 1.75rem !important;
}

.notifygif {
  width: 100%;
  padding-right: 0.5px;
  padding-left: 0.5px;
}

/*LOGIN STYLES*/
.bg-size {
  background-size: 100%;
}

@media (min-width: 993px) {
  .offcanvas.offcanvas-right.offcanvas-on {
    transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;
    right: 0;
    left: auto;
    margin-top: 0px !important;
  }
}

.bg-btn-default {
  background-color: #e4e6eb !important;
}

.bg-btn-default-red {
  background-color: #c90f1f !important;
  color: white;
  border: 1px solid #c90f1f;
}

.bg-btn-default-green {
  background-color: #c90f1f !important;
  color: white;
  border: 1px solid #c90f1f;
}

.bg-btn-default-blue {
  background-color: #004aad !important;
  color: white;
  border: 1px solid #004aad;
}

@media (max-width: 992px) {
  .card {
    margin-top: 15px !important;
  }

  .bg-size {
    background-size: 55% !important;
  }

  .modal-dialog {
    max-width: 90% !important;
  }
}

@media (max-width: 662px) {
  .bg-size {
    background-size: 75% !important;
    margin-bottom: 10px;
  }

  .notifygif {
    width: 100%;
    padding-right: 90.5px;
    padding-left: 90.5px;
    margin-bottom: 12px;
  }

  .modal-dialog {
    max-width: 100% !important;
    margin-left: 5px;
    margin-right: 5px;
  }

  .fijo {
    position: inherit !important;
    height: 100% !important;
    z-index: 0;
  }

  /*  .header-fixed .header {
    position: fixed;
    top: 0;
    right: 0;
    left: 0;
    z-index: 97;
    height: auto!important;
    -webkit-transition: all 0.3s ease;
    transition: all 0.3s ease;
  } */
}

.tarjetalogin {
  width: 35% !important;
}

.movil {
  display: inline-block !important;
}

.movilshow {
  display: none !important;
}

@media (max-width: 991.98px) {
  .header-mobile-fixed .wrapper {
    padding-top: 0px;
  }

  .movil {
    display: none !important;
  }

  .movilshow {
    display: block !important;
  }

  .tarjetalogin {
    width: 90% !important;
  }

  /* .header-mobile-fixed .header-mobile {
  position: fixed;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 3000;
  height: 55px;
  min-height: 64px;
} */

  .bg-size {
    background-size: 75% !important;
    margin-bottom: 10px;
  }

  .notifygif {
    width: 100%;
    padding-right: 90.5px;
    padding-left: 90.5px;
    margin-bottom: 12px;
  }

  .modal-dialog {
    max-width: 100% !important;
    margin-left: 5px;
    margin-right: 5px;
  }

  .fijo {
    position: inherit !important;
    height: 100% !important;
    z-index: 0 !important;
  }

  .fijopanelleft {
    margin-left: 0 !important;
  }
}

/*Acordion estylos personalizados*/
.card-header-acordion {
  padding: 0rem 2.25rem;
  margin-bottom: 0;
  background-color: #e8f0fe;
  border-bottom: none;
  color: black !important;
  border-radius: none !important;
}

.card-header:first-child {
  border-radius: none !important;
}

.transicioncolor {
  background-color: #9b59b6;
  transition: font-size 1s ease;
}

.negrita {
  font-weight: bold !important;
}

.card.card-custom > .card-body {
  padding: 0;
}

.btn {
  border-radius: none !important;
}

.btn-menu-personalizado {
  display: inline-block;
  font-weight: normal;
  color: #3f4254;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.65rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: none;
}

.btn {
  display: inline-block;
  font-weight: normal;
  color: #3f4254;
  text-align: center;
  vertical-align: middle;
  -webkit-user-select: none;
  user-select: none;
  background-color: transparent;
  border: 1px solid transparent;
  padding: 0.65rem 1rem;
  font-size: 1rem;
  line-height: 1.5;
  border-radius: 0rem;
  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out,
    border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;
}

/* .header-fixed .wrapper {
    padding-top: 51px !important;
  } */

.bordetr {
  box-shadow: 0px 2px 2px 0px rgb(202 212 228);
  cursor: pointer;
}

.bordetr:hover {
  background-color: #e3e3e3;
}

.cursor {
  cursor: pointer !important;
}

.cursorselect :hover {
  background-color: #fc4718;
  color: white;
}

#btn-0:hover {
  background-color: #f5f4f4 !important;
}

#btn-1:hover {
  background-color: #f5f4f4 !important;
}

#btn-2:hover {
  background-color: #f5f4f4 !important;
}

#btn-3:hover {
  background-color: #f5f4f4 !important;
}

#btn-perfil1:hover {
  background-color: #dc3545 !important;
}

.container {
  max-width: 100% !important;
}

.fijo {
  position: fixed;
  height: 100%;
  background: none;
}

.titulosSize {
  font-size: 15px !important;
  font-weight: bold;
  color: grey;
}

.menuitemsize {
  font-size: 10px !important;
  font-weight: bold;
  margin-left: 12px;
  text-decoration: none;
  color: black;
  float: left;
}

.menu_container .link {
  padding-left: 20px;
  /*   border-bottom: #fff 0.5px solid;
 */
}

.link {
  display: flex;
  color: white !important;
  gap: 10px;
  padding: 5px 7px;
  border-right: 4px solid transparent;
  transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

.link:hover {
  border-right: 4px solid #f6dfda;
  background: #f6dfda;
  transition: 0.1s cubic-bezier(0.6, -0.28, 0.735, 0.045);
}

.link:hover > * {
  color: black;
  fill: black;
}

.menu_item {
  display: flex;
  gap: 10px;
}

.menu_container {
  display: flex;
  flex-direction: column;
}

.floatderecha {
  float: right;
}

.floatizquierda {
  float: left;
}

.initspan {
  background: none;
  color: black;
}

.menuspam {
  color: #dc3545;
}

/*=================*/
.custom-switch.custom-switch-sm .custom-control-label::after {
  width: calc(1rem - 4px);
  height: calc(1rem - 4px);
  border-radius: calc(1rem - (1rem / 2));
}

.custom-switch.custom-switch-sm
  .custom-control-input:checked
  ~ .custom-control-label::after {
  transform: translateX(calc(1rem - 0.25rem));
}

/* for md */

.custom-switch.custom-switch-md .custom-control-label {
  padding-left: 2rem;
  padding-bottom: 1.5rem;
}

.custom-switch.custom-switch-md .custom-control-label::before {
  height: 1.5rem;
  width: calc(2rem + 0.75rem);
  border-radius: 3rem;
}

.custom-switch.custom-switch-md .custom-control-label::after {
  width: calc(1.5rem - 4px);
  height: calc(1.5rem - 4px);
  border-radius: calc(2rem - (1.5rem / 2));
}

.custom-switch.custom-switch-md
  .custom-control-input:checked
  ~ .custom-control-label::after {
  transform: translateX(calc(1.5rem - 0.25rem));
}

/* for lg */

.custom-switch.custom-switch-lg .custom-control-label {
  padding-left: 3rem;
  padding-bottom: 2rem;
}

.custom-switch.custom-switch-lg .custom-control-label::before {
  height: 2rem;
  width: calc(3rem + 0.75rem);
  border-radius: 4rem;
}

.custom-switch.custom-switch-lg .custom-control-label::after {
  width: calc(2rem - 4px);
  height: calc(2rem - 4px);
  border-radius: calc(3rem - (2rem / 2));
}

.custom-switch.custom-switch-lg
  .custom-control-input:checked
  ~ .custom-control-label::after {
  transform: translateX(calc(2rem - 0.25rem));
}

/* for xl */

.custom-switch.custom-switch-xl .custom-control-label {
  padding-left: 4rem;
  padding-bottom: 2.5rem;
}

.custom-switch.custom-switch-xl .custom-control-label::before {
  height: 2.5rem;
  width: calc(4rem + 0.75rem);
  border-radius: 5rem;
}

.custom-switch.custom-switch-xl .custom-control-label::after {
  width: calc(2.5rem - 4px);
  height: calc(2.5rem - 4px);
  border-radius: calc(4rem - (2.5rem / 2));
}

.custom-switch.custom-switch-xl
  .custom-control-input:checked
  ~ .custom-control-label::after {
  transform: translateX(calc(2.5rem - 0.25rem));
}

/*STYLOS IMAGENES*/
.containerImg {
  position: relative;
  width: 100%;
}

.imageImg {
  opacity: 1;
  display: block;
  width: 100%;
  height: auto;
  transition: 0.5s ease;
  backface-visibility: hidden;
}

.middleImg {
  transition: 0.5s ease;
  opacity: 0;
  position: absolute;
  top: 50%;
  left: 50%;
  right: -41%;
  transform: translate(-50%, -50%);
  -ms-transform: translate(-50%, -50%);
  text-align: center;
}

.containerImg:hover .imageImg {
  opacity: 0.3;
}

.containerImg:hover .middleImg {
  opacity: 1;
}

.textImg {
  background-color: #0446aa;
  color: white;
  font-size: 16px;
  padding: 16px 32px;
}

.bgfondo {
  /*   background-color: #f0f2f5;
 */
  background-color: #1b3765;
}

.bgfondodark {
  background-color: #f0f2f5;
}

.bgfondo3 {
  background-color: #004aad !important;
}

.negrita {
  font-weight: bold;
}

.bordebottom {
  border-bottom: 1px solid #f0f2f5 !important;
}

.bordetop {
  border-top: 1px solid #f0f2f5;
}

.textTitleFondo {
  font-weight: 500;
}

.badgevet {
  margin-top: -13px;
  position: fixed;
  margin-left: -4px;
  padding: 6px;
  width: 23px;
  background: red;
  color: white;
  font-weight: bold;
  font-size: 14px;
}

.inputIcon {
  width: 15%;
  height: 45px;
  /*   box-shadow: 0px 0px 1px 1px #00000036; */
  z-index: 10;

  background: white;
}

.inputIconText {
  max-width: 20%;
  width: 20%;
  height: 45px;
  box-shadow: 0px 0px 1px 1px #00000036;
  z-index: 10;
}

.inputtext {
  width: 100%;
  padding: 12px;
  text-decoration: none;
  background: #f5f7fc !important;
  height: 45px !important;
  overflow: auto;
  border: none;
  outline: none;
  box-shadow: none;

  resize: none;
}

.inputtext2 {
  width: 100%;
  padding: 10px;
  text-decoration: none;
  background: white !important;
  height: 45px !important;
  overflow: auto;
  border: none;
  outline: none;
  box-shadow: none;

  resize: none;
}

.inputtext3 {
  width: 100%;
  padding: 10px;
  text-decoration: none;
  background: white !important;
  height: 40px !important;
  overflow: auto;
  border: none;
  outline: none;
  box-shadow: none;
  border-radius: 5px !important;

  resize: none;
}

.inputselect {
  width: 100%;
  padding: 12px;
  text-decoration: none;
  background: #f5f7fc !important;
  border-radius: 0px;
  height: 45px !important;
  overflow: auto;
  border: none;
  outline: none;
  box-shadow: none;

  resize: none;
}

.inputselect2 {
  width: 100%;
  padding: 12px;
  text-decoration: none;
  background: white !important;
  border-radius: 5px;
  height: 45px !important;
  overflow: auto;
  border: none;
  outline: none;
  box-shadow: none;

  resize: none;
}

.textareapublicar {
  width: 100%;
  padding: 12px;
  text-decoration: none;
  background: #f0f2f5 !important;
  border-radius: 5px;
  overflow: hidden;
  border: none;
  outline: none;
  box-shadow: none;
  text-align: justify;
  text-justify: inter-word;
  resize: vertical;
}

.borde-tarjetapublicacion {
  box-shadow: 0px 3px 8px 1px rgb(169 164 164 / 68%);
  border: 1px solid #ced4da !important;
  background-clip: border-box !important;
}

.selector {
  /* definir una altura pequeña para forzar el scroll */
  height: 100px;
  overflow-y: scroll;
  width: 400px;

  /* cambiar el estilo por defecto de la barra de scroll */
  scrollbar-color: black white;
  scrollbar-width: 25px;
}

div::-webkit-scrollbar {
  height: 10px;
  width: 10px;
}

div::-webkit-scrollbar-track {
  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
}

div::-webkit-scrollbar-thumb {
  background-color: grey;
  outline: 0px solid white;
  border-radius: 30px;
}

@media (min-width: 992px) {
  .header-fixed .wrapper {
    padding-top: 60px !important;
  }
}

@media (max-width: 425px) {
  .offcanvas {
    width: 100% !important;
  }
}

legend {
  display: block;
  width: 50% !important;
  max-width: 100%;
  min-width: 50%;
  padding: 8px 6px;
  margin: 0px !important;
  margin-bottom: 0.5rem;
  margin-left: -1px !important;
  font-size: 1.5rem;
  line-height: inherit;
  color: black;
  font-weight: bold;
  white-space: normal;
  background-color: white;
  margin-top: -10px !important;
  background-color: #ffff;
  border: 1px solid #bdc3c7 !important;
}

fieldset {
  min-width: 100%;
  padding: 12px;
  margin: 0;
  border-style: double;
  background-color: #fff;
  border: 1px solid #bdc3c7 !important;
}

.bad {
  position: absolute !important;
  top: 2px !important;
  margin-left: 10px;
  height: 23px;
  background-color: #2196f3;
  color: white !important;
}

.muted > * {
  color: #b5b5c3;
}

.badge-danger {
  color: #ffffff;
  background-color: red;
}

.badge-success {
  color: #ffffff;
  background-color: green;
}

.acomodate {
  width: 230px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.chat_submit_box {
  bottom: 12px !important;
  box-sizing: border-box;
  left: 0;
  overflow: hidden;
  padding: 2px;
  position: absolute;
  width: 100%;
  border: 1px solid #ccc;
  background-color: white;
}

.borde-tarjeta-login {
  box-shadow: 3px 7px 15px 1px rgb(21, 19, 19);
  background-clip: border-box !important;
}

.toast-error {
  border: none !important;
  background-color: rgb(247, 108, 108) !important;
  text-align: center;
  margin: 0;
}

.tituloestilo {
  font-size: 1.5rem !important;
}

.tituloestilo:hover {
  color: #7ac0f7;
}

.desc {
  overflow: hidden;
  font-size: 1rem;
  line-height: 20px;
  color: #737373;
  text-overflow: ellipsis;
}

.novisto {
  background-color: #e7e7e7a3 !important;
}

.visto {
  background-color: white !important;
}

.topContainer {
  display: -webkit-box;
  flex-direction: row;
  overflow: auto;
  max-width: 440px !important;
  margin-left: 5px;
  margin-bottom: 12px;
}

.wraper {
  flex-wrap: wrap;
  max-width: 120px;
  min-width: 120px;
}

.textoPerfil {
  font-size: 12px;
  text-align: left;
}

.btn-primary-vet {
  background-color: #004aad !important;
  border-color: #004aad !important;
}

.text-btn {
  font-size: 10px !important;
}

.borde-botones {
  box-shadow: 4px 4px 3px 0px rgba(9, 9, 9, 0.35);
  background-clip: border-box !important;
}

.bg-btn-vet {
  padding: 8px 8px !important;
  border-radius: 5px !important;
  border: 1px solid #e4e6eb !important;
  border-color: #e4e6eb !important;
  background-color: #e4e6eb !important;
  color: black !important;
  font-weight: bold !important;
}

.bg-btn-small-circle-check {
  padding: 4px 4px !important;
  border-radius: 50% !important;
  border: 1px solid #67ba52 !important;
  border-color: #67ba52 !important;
  background-color: #67ba52 !important;
  color: white !important;
  font-weight: bold !important;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: center;
}

.bg-btn-small-circle {
  padding: 4px 4px !important;
  border-radius: 50% !important;
  border: 1px solid #e4e6eb !important;
  border-color: #e4e6eb !important;
  background-color: #e4e6eb !important;
  color: black !important;
  font-weight: bold !important;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: centerx;
}

.bg-btn-small-circle-danger {
  padding: 4px 4px !important;
  border-radius: 50% !important;
  border: 1px solid #d70c0c !important;
  border-color: #d70c0c !important;
  background-color: #d70c0c !important;
  color: white !important;
  font-weight: bold !important;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: centerx;
}
.bg-btn-small-circle-white {
  padding: 4px 4px !important;
  border-radius: 50% !important;
  border: 1px solid #ffffff !important;
  border-color: #ffffff !important;
  background-color: #ffffff !important;
  color: black !important;
  font-weight: bold !important;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  align-self: centerx;
}

h5 {
  margin: 0 !important;
}

.bg-btn-vet-opciones {
  /* padding: 8px 8px !important; */
  border-radius: 5px !important;
  border: 1px solid #e4e6eb !important;
  border-color: #e4e6eb !important;
  background-color: #e4e6eb !important;
  color: black !important;
  font-weight: bold !important;
  height: 35px !important;
}

.bg-btn-vet-login {
  padding: 8px 8px !important;
  border-radius: 5px !important;

  color: #f0f2f5 !important;
  font-weight: bold !important;
}

.bg-vet-blue {
  background-color: #004aad !important;
}

.colorwhite {
  color: white !important;
}

.colorblack {
  color: black !important;
}

.bg-btn-vet-danger {
  padding: 8px 8px !important;
  border-radius: 5px !important;
  border: 1px solid #dc3545 !important;
  border-color: #dc3545 !important;
  background-color: #dc3545 !important;
  color: white !important;
  font-weight: bold !important;
}

.bg-btn-vet-warning {
  padding: 8px 8px !important;
  border-radius: 5px !important;
  border: 1px solid #ffa500 !important;
  border-color: #ffa500 !important;
  background-color: #ffa500 !important;
  color: black !important;
  font-weight: bold !important;
}

/* Botón de Ocultar */
.bg-btn-hide {
  padding: 8px 8px !important;
  border-radius: 5px !important;
  border: 1px solid #666 !important;
  border-color: #666 !important;
  background-color: #666 !important;
  color: white !important;
  font-weight: bold !important;
}

/* Botón de Publicar */
.bg-btn-publish {
  padding: 8px 8px !important;
  border-radius: 5px !important;
  border: 1px solid #00c853 !important;
  border-color: #00c853 !important;
  background-color: #00c853 !important;
  color: white !important;
  font-weight: bold !important;
}

/* Botón de Nuevo */
.bg-btn-new {
  padding: 8px 8px !important;
  border-radius: 5px !important;
  border: 1px solid #2196f3 !important;
  border-color: #2196f3 !important;
  background-color: #2196f3 !important;
  color: white !important;
  font-weight: bold !important;
}

.titulosubmenusize {
  font-size: 14px !important;
}

.bg-btn-sm {
  font-size: 9px !important;
  padding: 5px !important;
}

.react-datalist-input__textbox {
  width: 100%;
  font-size: 0.875rem;
  line-height: 1.25rem;
  margin: 0;
  border: none !important;
  background: #ffff !important;
  height: 40px !important;
  border-radius: none !important;
}

.botoneliminar {
  font-size: 10px;
}

.bordecompleto {
  border: 1px solid #ced4da !important;
}

.bordecompletoerror {
  border: 3px solid #dc3545 !important;
}

.bordevertical {
  border-top: 1px solid #ced4da !important;
  border-bottom: 1px solid #ced4da !important;
}

.form-control {
  border: none !important;
}

.bgfondo2 {
  /* background-color: #f0f2f5; */
  background-color: #f6dfda;
}

.modal80 {
  max-width: 80% !important;
}

.tabla-detalle-factura thead tr {
  text-align: center;
  background: #f5f7fc !important;
}

.tabla-detalle-factura thead tr th {
  padding: 12px !important;
}

.tabla-detalle-factura tbody tr {
  text-align: center;
  background: #ffff !important;
}

.tabla-detalle-factura tbody tr td {
  padding: 8px !important;
}

.emisor tbody tr td {
  padding: 3px !important;
}

.tablares {
  width: 100%;
  overflow-x: auto;
}

.btn-tabla-factura {
  width: 40px;
  height: 35px;
  border: none;
}

.borderadiusinput {
  border-radius: 5px;
}

.bordesuperiorizquierdo {
  border-top-left-radius: 20px;
}

.bordeinferiorizquierdo {
  border-bottom-left-radius: 20px;
}

.bordesuperiorderecho {
  border-top-right-radius: 20px;
}

.bordeinferiorderecho {
  border-bottom-right-radius: 20px;
}

.espacioderecho {
  margin-right: 10px;
}

.active-descuento {
  background-color: #004aad;
  color: white;
}

.svg2 {
  width: 100% !important;
  height: auto !important;
}

.svgpreloadfactura {
  width: 150px !important;
  height: auto !important;
}

.tabalconmenu {
  position: relative;
  width: 100%;
  border-radius: inherit;
  overflow-x: inherit !important;
  overflow-y: inherit !important;
  min-height: 0;
  max-height: 300px;
  -webkit-overflow-scrolling: touch;
}

.scrollx {
  overflow-x: scroll;
}

.scrollauto {
  overflow-x: auto;
}

.scrollin {
  overflow-x: inherit;
}

/* .ddmenu{
  margin-left: -120px!important;
  position :inherit!important
} */

/*.
sc-dmRaPn
iXRfeU */

.bordederecho {
  border-right: 1px solid #ced4da !important;
}

.bordeizquierdo {
  border-left: 1px solid #ced4da !important;
}

.bordearriba {
  border-top: 1px solid #ced4da !important;
}

.bordeabajo {
  border-bottom: 1px solid #ced4da !important;
}

.bordevertical {
  border-left: none !important;
  border-right: none !important;
  border-bottom: 1px solid #ced4da !important;
  border-top: 1px solid #ced4da !important;
}

.bordehorizontal {
  border-bottom: none !important;
  border-top: none !important;
  border-left: 1px solid #ced4da !important;
  border-right: 1px solid #ced4da !important;
}

.dropoculto {
  display: none !important;
}

.textmenu {
  font-size: 13px !important;
  font-weight: 750 !important;
}

.infoadicional {
  width: 100%;
  padding: 25px;
  text-decoration: none;
  background: #fdfdfd !important;
  border-radius: 5px;
  overflow: hidden;
  border: none;
  outline: none;
  box-shadow: none;
  text-align: justify;
  text-justify: inter-word;
  resize: vertical;
}

.btn-mediano {
  width: 120px !important;
}

.bg-green {
  background-color: rgb(37, 164, 37);
  color: white;
}

.listadocumentos {
  height: 50px;
  width: 33.3%;
  background-color: white;
  color: black;
  font-size: 12px;
  font-weight: bold;
  border: none;
}

.listadocumentos:hover {
  background-color: #fc4718;
  color: white;
}

.documentoactivo {
  background-color: #243c54;
  color: white;
}

.scrollx {
  overflow-x: scroll;
}

.accordion-body {
  padding: 0;
}

.imanav {
  height: 50px;
  width: 50px;
}

.w-70 {
  width: 70%;
}

.w-30 {
  width: 30%;
}

@media (max-width: 662px) {
  .w-70 {
    width: 0%;
  }

  .w-30 {
    width: 100%;
    margin: 12px;
  }
}

.modal-backdrop.show {
  opacity: 0.8;
  background-color: white;
}

.bordesombreado {
  box-shadow: 1px 2px 3px 0px rgb(141 143 147);
  background-clip: border-box !important;
  /* box-shadow: 0 0 7px 0px rgb(187, 188, 191); */
}

.toast-message-error {
  background: red;
  color: #fff;
  font-size: 20px;
  padding: 12px 12px;
  margin: 12px;
  width: 100%;
  fill: white;
}

.toast-message-error svg {
  fill: white;
}

label {
  padding: 0px;
}

.titulomenutabla {
  width: 9px !important;
}

.size16 {
  font-size: 16px !important;
}

.size17 {
  font-size: 17px !important;
}

.size18 {
  font-size: 18px !important;
}

button > *:hover {
  cursor: pointer;
}

.accordion-button:not(.collapsed) {
  color: white;
  background-color: #243c54;
  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);
}

.accordion-button:focus {
  z-index: 3;
  border-color: #eff1f5;
  outline: 0;
  box-shadow: 0 0 0 0.25rem rgb(255 255 255 / 25%);
}

.viewer {
  background-color: #e4e4e4;
  display: flex;
  justify-content: center;
  align-items: center;
  height: 800px;
  overflow-y: auto;
  margin-bottom: 10px;
}

.azulmarino {
  background-color: #243c54 !important;
}

.azulindigo {
  background-color: #00416a;
}
.text-white {
  color: white;
}

.color-azulmarino {
  color: #243c54 !important;
}

.naranja {
  background-color: #fc4718 !important;
}

.color-naranja {
  color: #fc4718 !important;
}

.plomo {
  background-color: #dcd3d4 !important;
}

.color-plomo {
  color: #dcd3d4 !important;
}

.color-blanco {
  color: #ffff !important;
}

.borderradiusnone {
  border-radius: 0 !important;
}

.iconmenu {
  font-size: 16px !important;
}

.hovernaranja:hover {
  background-color: #fc4718 !important;
  color: white !important;
}

.card-custom {
  overflow: hidden;
  min-height: 300px;
  box-shadow: 0 0 5px rgba(10, 10, 10, 0.3);
  border: 1px solid rgb(64, 59, 59);
}

.card-custom-2 {
  overflow: hidden;
  width: 100%;
  min-height: 10px;
  box-shadow: 0 0 5px rgba(10, 10, 10, 0.3);
  border: 1px solid rgb(3, 2, 2);
}

.borde-tarjeta-derecho {
  box-shadow: 0px 0px 7px rgb(200, 193, 193);
  background-clip: border-box !important;
  /* box-shadow: 0 0 7px 0px rgb(187, 188, 191); */
}

.objetocircular {
  border-radius: 50%;
}

.proyectoN {
  background-color: #02426a68;
}

.proyecto {
  background-color: #d20d0d;
}

.desactivar {
  background-color: #ffbfbf !important ;
}

.backimage {
  background-image: url("https: //upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Link_at_Igromir_2012.jpg/320px-Link_at_Igromir_2012.jpg");
}

.uploadbanner:hover {
  opacity: 0.6;
}
.uploadbanner {
  opacity: 0;
}
.fondocolor {
  background-color: #f6dfda;
}

.fondocolorBlue {
  background-color: #1b3765;
}

.letrablanca {
  color: white;
}

/* grupos de acceso */

.collage-badge {
  background-color: #47637a;
  color: white;
  padding: 5px 10px;
  border-radius: 10px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  text-align: center;
  margin-bottom: 5px;
}

.react-select__value-container {
  overflow-y: auto !important;
  max-height: 80px;
}

.text-table-sm {
  padding: 0.4375rem 0.625rem;
  font-size: 0.875rem;
}

.mantine-DatePickerInput-input {
  border-radius: 5px !important;
  height: 45px;
  width: 100%;
  max-width: 100%;
}

.mantine-DatePickerInput-wrapper {
  border-radius: 5px !important;
  width: 100%;
  max-width: 100%;
}

.mantine-InputWrapper-root {
  border-radius: 5px !important;
  width: 100%;
  max-width: 100%;
}

#proxy-renderer {
  overflow: hidden;
  display: flex;
  justify-content: center;
}

#no-renderer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  padding: 20px;
}

#no-renderer-download {
  width: 250px;
}

#pdf-controls {
  z-index: 100;
}

.scrollable-div::-webkit-scrollbar {
  width: 5px;
}

.scrollable-div::-webkit-scrollbar-track {
  background: #ddd;
  border-radius: 0 2px 2px 0;
}

.scrollable-div::-webkit-scrollbar-thumb {
  background: #666;
  border-radius: 0 2px 2px 0;
}

.scrollable-div::-webkit-scrollbar-thumb:hover {
  background: #555;
}

.input-user-code div input {
  font-size: 4rem;
  margin-top: 7px;
  height: 80px;
}


.button-keyboard-numeric-animation {
  transition: all 0.1s;
}

.button-keyboard-numeric-animation:active {
  transform: scale(1.3);
  background-color: #1b3765;
}

.button-acept-animation {
  transition: all 0.2s;
}

.button-acept-animation:active {
  transform: scale(1.3);
  background-color: #0c803c;
}

.btnconfirmar{
  height: 150px!important;
}

*{
  font-family: "Source Sans 3", system-ui, -apple-system, "Segoe UI", Roboto, "Helvetica Neue", "Noto Sans", "Liberation Sans", Arial, sans-serif, "Apple Color Emoji", "Segoe UI Emoji", "Segoe UI Symbol", "Noto Color Emoji";
    font-size: 14px;
}


.small-box .small-box-icon {
  position: absolute;
  top: 15px;
  right: 15px;
  z-index: 0;
  height: 70px;
  font-size: 70px;
  color: rgba(0, 0, 0, 0.15);
  transition: transform 0.3s linear;
}   

.small-box {
  border-radius: 0.375rem;
  box-shadow: 0 0 1px rgba(var(--bs-body-color-rgb), 0.125), 0 1px 3px rgba(var(--bs-body-color-rgb), 0.2);
  position: relative;
  display: block;
  margin-bottom: 1.25rem;
  --bs-link-color-rgb: none;
  --bs-link-hover-color-rgb: none;
  --bs-heading-color: none;
}

.small-box > * {
  color:white
}


.td-consolidado{
  border-bottom: 1px solid rgba(71, 70, 70, 0.25);
}`, "",{"version":3,"sources":["webpack://./src/index.css"],"names":[],"mappings":"AAAA;EACE,+DAA+D;EAC/D;;;;;+BAK6B;EAC7B;EACA;EACA,yBAAyB;EACzB,0BAA0B;EAC1B,yBAAyB;EACzB,6NAA6N;;AAE/N;EACE,eAAe;AACjB;;AAEA;EACE,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;AACnB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;AAC5B;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,eAAe;EACf,MAAM;EACN,QAAQ;EACR,OAAO;EACP,aAAa;EACb,YAAY;EAEZ,yBAAyB;AAC3B;;AAEA;EACE,gCAAgC;EAChC,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iCAAiC;AACnC;;AAEA;EACE,6CAA6C;AAC/C;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,iDAAiD;AACnD;;AAEA;EACE;oCACkC;AACpC;;AAEA;EACE,sCAAsC;EACtC,qCAAqC;EACrC,qCAAqC;AACvC;;AAEA;;KAEK;AACL;EACE,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,kBAAkB;EAGlB,aAAa;EAIb,sBAAsB;EACtB,YAAY;EACZ,qBAAqB;EACrB,yBAAyB;EACzB,2BAA2B;EAC3B,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,gBAAgB;EAChB,yBAAyB;EACzB,gCAAgC;EAChC,cAAc;EACd,6CAA6C;AAC/C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,4BAA4B;EAC5B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,uBAAuB;EACvB,WAAW;AACb;;AAEA;EACE,kCAAkC;EAClC,yBAAyB;EACzB,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB;EACA;AACF;;AAEA;EACE,kCAAkC;EAClC,uBAAuB;EACvB,8BAA8B;EAC9B,uBAAuB;EACvB,YAAY;EACZ,WAAW;EACX,YAAY;AACd;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,8CAA8C;EAC9C,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,0BAA0B;AAC5B;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,WAAW;EACX,oBAAoB;EACpB,mBAAmB;AACrB;;AAEA,eAAe;AACf;EACE,qBAAqB;AACvB;;AAEA;EACE;IAGE,4EAA4E;IAC5E,QAAQ;IACR,UAAU;IACV,0BAA0B;EAC5B;AACF;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,YAAY;EACZ,yBAAyB;AAC3B;;AAEA;EACE;IACE,2BAA2B;EAC7B;;EAEA;IACE,+BAA+B;EACjC;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,UAAU;EACZ;;EAEA;;;;;;;;;KASG;AACL;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,gBAAgB;EAClB;;EAEA;IACE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,qBAAqB;EACvB;;EAEA;;;;;;;;GAQC;;EAED;IACE,+BAA+B;IAC/B,mBAAmB;EACrB;;EAEA;IACE,WAAW;IACX,qBAAqB;IACrB,oBAAoB;IACpB,mBAAmB;EACrB;;EAEA;IACE,0BAA0B;IAC1B,gBAAgB;IAChB,iBAAiB;EACnB;;EAEA;IACE,4BAA4B;IAC5B,uBAAuB;IACvB,qBAAqB;EACvB;;EAEA;IACE,yBAAyB;EAC3B;AACF;;AAEA,kCAAkC;AAClC;EACE,qBAAqB;EACrB,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,yBAAyB;EAEzB,6BAA6B;AAC/B;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,qBAAqB;EACrB,mBAAmB;EACnB,cAAc;EACd,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;EAGzB,iBAAiB;EACjB,6BAA6B;EAC7B,6BAA6B;EAC7B,qBAAqB;EACrB,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EAKnB;8DAC4D;AAI9D;;AAEA;;KAEK;;AAEL;EACE,4CAA4C;EAC5C,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,0BAA0B;EAC1B,iBAAiB;EACjB,iBAAiB;EACjB,qBAAqB;EACrB,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB;EACA;AACF;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,gBAAgB;EAChB,mCAAmC;EACnC,uDAAuD;AACzD;;AAEA;EACE,+BAA+B;EAC/B,mBAAmB;EACnB,uDAAuD;AACzD;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,aAAa;EACb,SAAS;AACX;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,uBAAuB;EACvB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,uBAAuB;EACvB,wBAAwB;EACxB,sCAAsC;AACxC;;AAEA;;;EAGE,2CAA2C;AAC7C;;AAEA,WAAW;;AAEX;EACE,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;EACzB,0BAA0B;EAC1B,wCAAwC;AAC1C;;AAEA;;;EAGE,6CAA6C;AAC/C;;AAEA,kBAAkB;AAClB;EACE,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,UAAU;EACV,cAAc;EACd,WAAW;EACX,YAAY;EACZ,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,qBAAqB;EACrB,UAAU;EACV,kBAAkB;EAClB,QAAQ;EACR,SAAS;EACT,WAAW;EACX,gCAAgC;EAChC,oCAAoC;EACpC,kBAAkB;AACpB;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE;EACA;EACA,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,iBAAiB;AACnB;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,iBAAiB;EACjB,YAAY;EACZ,WAAW;EACX,eAAe;EACf,YAAY;EACZ,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,UAAU;EACV,YAAY;EACZ,6CAA6C;EAC7C,WAAW;;EAEX,iBAAiB;AACnB;;AAEA;EACE,cAAc;EACd,UAAU;EACV,YAAY;EACZ,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EAGb,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EAGb,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EAGb,gBAAgB;EAChB,6BAA6B;;EAE7B,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EAGb,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,4BAA4B;EAC5B,kBAAkB;EAClB,uBAAuB;EACvB,cAAc;EACd,YAAY;EACZ,aAAa;EAGb,gBAAgB;;EAEhB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EAGb,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,kDAAkD;EAClD,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,qDAAqD;EACrD,aAAa;EACb,kBAAkB;EAClB,YAAY;;EAEZ,wDAAwD;EACxD,4BAA4B;EAC5B,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,4CAA4C;AAC9C;;AAEA;EACE,sBAAsB;EACtB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE;IACE,4BAA4B;EAC9B;AACF;;AAEA;EACE;IACE,sBAAsB;EACxB;AACF;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,eAAe;EACf,cAAc;EACd,gBAAgB;EAChB,sBAAsB;EACtB,qBAAqB;EACrB,4BAA4B;EAC5B,iBAAiB;EACjB,oBAAoB;EACpB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,oCAAoC;AACtC;;AAEA;EACE,eAAe;EACf,aAAa;EACb,SAAS;EACT,oBAAoB;EACpB,sBAAsB;EACtB,oCAAoC;AACtC;;AAEA;EACE,6BAA6B;EAC7B,mBAAmB;EACnB,iBAAiB;EACjB,YAAY;EACZ,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,sBAAsB;EACtB,OAAO;EACP,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;AACxC;;AAEA;EACE,uBAAuB;EACvB,+CAA+C;EAC/C,kBAAkB;EAClB,SAAS;AACX;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,cAAc;EACd,uBAAuB;AACzB;;AAEA;EACE,sCAAsC;AACxC;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,2BAA2B;EAC3B,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,+CAA+C;EAC/C,sCAAsC;AACxC;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;AACA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,WAAW;EACX,YAAY;EACZ,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,iCAAiC;EACjC,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;;EAE7B,yBAAyB;EACzB,4BAA4B;AAC9B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,qBAAqB;AACrB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,iCAAiC;EACjC,6BAA6B;EAC7B,iCAAiC;EACjC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,sBAAsB;AACtB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA,mBAAmB;AACnB;EACE,2BAA2B;EAC3B,6BAA6B;EAC7B,oCAAoC;EACpC,gCAAgC;EAChC,oCAAoC;EACpC,uBAAuB;EACvB,4BAA4B;AAC9B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,yBAAyB;EACzB,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,oBAAoB;EACpB,SAAS;EACT,uBAAuB;EACvB,4BAA4B;EAC5B,uBAAuB;EACvB,8BAA8B;AAChC;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,wCAAwC;EACxC,2CAA2C;AAC7C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,+BAA+B;EAC/B,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;EAClB,8BAA8B;AAChC;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,kBAAkB;EAClB,4BAA4B;AAC9B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;AAC/B;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,sBAAsB;EACtB,uBAAuB;AACzB;;AAEA;EACE,uBAAuB;EACvB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,sBAAsB;EACtB,8BAA8B;EAC9B,8BAA8B;EAC9B,aAAa;EACb,iBAAiB;EACjB,iCAAiC;AACnC;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;;GAGG;;AAEH;;QAEQ;;AAER;EACE,0CAA0C;AAC5C;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,wCAAwC;AAC1C;;AAEA;EACE,2CAA2C;AAC7C;;AAEA;EACE,4BAA4B;EAC5B,6BAA6B;EAC7B,2CAA2C;EAC3C,wCAAwC;AAC1C;;AAEA;EACE,8BAA8B;EAC9B,2BAA2B;EAC3B,yCAAyC;EACzC,0CAA0C;AAC5C;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE,0BAA0B;EAC1B,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,aAAa;EACb,qBAAqB;EACrB,8BAA8B;EAC9B,kBAAkB;EAClB,gBAAgB;EAChB,YAAY;EACZ,aAAa;EAGb,gBAAgB;EAChB,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,kCAAkC;EAClC,YAAY;AACd;;AAEA;EACE,YAAY;EACZ,YAAY;EACZ,uBAAuB;EACvB,YAAY;EACZ,eAAe;EACf,iBAAiB;EACjB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,yBAAyB;EACzB,YAAY;AACd;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,YAAY;EACZ,WAAW;AACb;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE;IACE,SAAS;EACX;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF;;AAEA;EACE,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,4CAA4C;EAC5C,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;EACf,kBAAkB;EAClB,YAAY;EACZ,WAAW;EACX,WAAW;AACb;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,yBAAyB;EACzB,+CAA+C;AACjD;;AAEA;EACE,UAAU;EACV,qBAAqB;EACrB,UAAU;EACV,gDAAgD;AAClD;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;AACA;EACE,YAAY;AACd;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,0BAA0B;AAC5B;;AAEA;EACE,oCAAoC;EACpC,uBAAuB;AACzB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,yCAAyC;EACzC,iCAAiC;AACnC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,yCAAyC;EACzC,8BAA8B;AAChC;;AAEA;EACE,0CAA0C;EAC1C,sCAAsC;EACtC,gDAAgD;AAClD;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qCAAqC;AACvC;;AAEA;EACE,2IAA2I;AAC7I;;AAEA;EACE,YAAY;AACd;AACA;EACE,UAAU;AACZ;AACA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,YAAY;AACd;;AAEA,qBAAqB;;AAErB;EACE,yBAAyB;EACzB,YAAY;EACZ,iBAAiB;EACjB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,2BAA2B;EAC3B,gBAAgB;AAClB;;AAEA;EACE,2BAA2B;EAC3B,mBAAmB;AACrB;;AAEA;EACE,6BAA6B;EAC7B,YAAY;EACZ,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,6BAA6B;EAC7B,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,sBAAsB;EACtB,aAAa;AACf;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;EAChB,0BAA0B;AAC5B;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,eAAe;EACf,YAAY;AACd;;;AAGA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,qBAAqB;EACrB,yBAAyB;AAC3B;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,6NAA6N;IAC3N,eAAe;AACnB;;;AAGA;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,UAAU;EACV,YAAY;EACZ,eAAe;EACf,0BAA0B;EAC1B,iCAAiC;AACnC;;AAEA;EACE,uBAAuB;EACvB,wGAAwG;EACxG,kBAAkB;EAClB,cAAc;EACd,sBAAsB;EACtB,yBAAyB;EACzB,+BAA+B;EAC/B,wBAAwB;AAC1B;;AAEA;EACE;AACF;;;AAGA;EACE,+CAA+C;AACjD","sourcesContent":["body {\n  /* font-family:Verdana, Geneva, Tahoma, sans-serif!important; */\n  /* font-family: Helvetica Neue,\n    Helvetica,\n    Arial,\n    sans-serif!important;\n  text-shadow: 0px .1px 0px rgba(0, 0, 0, 0.65);\n  font-size: 13px !important; */\n  /*   letter-spacing: .2px;\n */\n  background-color: #f6dfda;\n  background-size: \"contain\";\n  background-repeat: repeat;\n  font-family: \"Source Sans 3\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\"}\n\n* {\n  font-size: 12px;\n}\n\n.svgIv {\n  width: 16px !important;\n  margin-right: 5px;\n}\n\n.faIv {\n  font-size: 14px !important;\n  margin-right: 5px;\n}\n\n.letra-blanca {\n  color: white !important;\n}\n\n.buscarpacientelist {\n  max-height: 350px;\n  overflow-y: scroll;\n}\n\n.w150 {\n  min-width: 150px !important;\n}\n\n.row > * {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.row {\n  margin-left: 0 !important;\n  margin-right: 0 !important;\n}\n\n.fijopanelleft {\n  margin-left: 25% !important;\n}\n\n.header-fixed .header {\n  position: fixed;\n  top: 0;\n  right: 0;\n  left: 0;\n  z-index: 1000;\n  height: 10vh;\n  -webkit-transition: all 0.3s ease;\n  transition: all 0.3s ease;\n}\n\na {\n  text-decoration: none !important;\n  color: #100f0f !important;\n  /* font-weight: 600; */\n}\n\n.acordionBotonColorText {\n  color: rgb(10, 10, 10) !important;\n}\n\n.borde-layout {\n  box-shadow: -1px 3px 6px 3px rgb(202 212 228);\n}\n\n.borde-tarjeta {\n  box-shadow: 0px 5px 8px rgb(200, 193, 193);\n  background-clip: border-box !important;\n  /*  box-shadow: 0 0 7px 0px rgb(187, 188, 191); */\n}\n\n.borde-modal {\n  box-shadow: 0 12px 28px 0 rgb(202 212 228), 0 2px 4px 0 rgb(202 212 228),\n    inset 0 0 0 1px rgb(202 212 228);\n}\n\n.borde {\n  --T68779821: 0 1px 2px var(--shadow-2);\n  --webkit-box-shadow: var(--T68779821);\n  box-shadow: 0 1px 2px var(--shadow-2);\n}\n\n/*  .borde {\n    box-shadow: 3px 3px 9px -6px rgb(89 97 103);\n  } */\n.zindex {\n  z-index: 90 !important;\n}\n\n.card {\n  border: none !important;\n  border-radius: 10px !important;\n}\n\n.card {\n  position: relative;\n  display: -webkit-box;\n  display: -ms-flexbox;\n  display: flex;\n  -webkit-box-orient: vertical;\n  -webkit-box-direction: normal;\n  -ms-flex-direction: column;\n  flex-direction: column;\n  min-width: 0;\n  word-wrap: break-word;\n  background-color: #ffffff;\n  background-clip: border-box;\n  border: 1px solid #ebedf3;\n  border-radius: 0rem;\n}\n\n.card-body {\n  padding: 12px;\n}\n\n.card-header {\n  padding: 12px;\n  margin-bottom: 0;\n  background-color: #f2eeee;\n  border-bottom: 1px solid #ebedf3;\n  color: #100f0f;\n  box-shadow: -1px 3px 6px 1px rgb(202 212 228);\n}\n\n.bg-Black {\n  background: rgb(42 46 51);\n}\n\n.bg-green {\n  background: green !important;\n  color: white !important;\n  margin: 1px;\n}\n\n.bg-red {\n  background: red !important;\n  color: white !important;\n  margin: 1px;\n}\n\n.bg-integralvet {\n  /*background: #2196f3 !important;*/\n  background-color: #007ee2;\n  border-bottom: \"1px solid #d8d8d8\";\n  color: white;\n}\n\n.bordecircular {\n  border-radius: 12px;\n}\n\n.bordecircularpanel {\n  border-radius: 20px;\n  /*   min-height: 50%;\n */\n}\n\n.modal .modal-header > button {\n  border: 1px solid black !important;\n  padding: 0px !important;\n  border-radius: 45px !important;\n  background-color: white;\n  color: black;\n  width: 30px;\n  height: 30px;\n}\n\n.modal-content {\n  /* padding: 12px; */\n  border-radius: 0px;\n  box-shadow: 0px 3px 8px rgb(169 164 164 / 68%);\n  background-clip: border-box !important;\n}\n\n.modal .modal-header .close span {\n  display: block !important;\n  color: black;\n  font-size: 18px !important;\n}\n\n.cabeceraNotify {\n  padding: 0.5rem 1.75rem !important;\n}\n\n.notifygif {\n  width: 100%;\n  padding-right: 0.5px;\n  padding-left: 0.5px;\n}\n\n/*LOGIN STYLES*/\n.bg-size {\n  background-size: 100%;\n}\n\n@media (min-width: 993px) {\n  .offcanvas.offcanvas-right.offcanvas-on {\n    -webkit-transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease,\n      top 0.3s ease;\n    transition: left 0.3s ease, right 0.3s ease, bottom 0.3s ease, top 0.3s ease;\n    right: 0;\n    left: auto;\n    margin-top: 0px !important;\n  }\n}\n\n.bg-btn-default {\n  background-color: #e4e6eb !important;\n}\n\n.bg-btn-default-red {\n  background-color: #c90f1f !important;\n  color: white;\n  border: 1px solid #c90f1f;\n}\n\n.bg-btn-default-green {\n  background-color: #c90f1f !important;\n  color: white;\n  border: 1px solid #c90f1f;\n}\n\n.bg-btn-default-blue {\n  background-color: #004aad !important;\n  color: white;\n  border: 1px solid #004aad;\n}\n\n@media (max-width: 992px) {\n  .card {\n    margin-top: 15px !important;\n  }\n\n  .bg-size {\n    background-size: 55% !important;\n  }\n\n  .modal-dialog {\n    max-width: 90% !important;\n  }\n}\n\n@media (max-width: 662px) {\n  .bg-size {\n    background-size: 75% !important;\n    margin-bottom: 10px;\n  }\n\n  .notifygif {\n    width: 100%;\n    padding-right: 90.5px;\n    padding-left: 90.5px;\n    margin-bottom: 12px;\n  }\n\n  .modal-dialog {\n    max-width: 100% !important;\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  .fijo {\n    position: inherit !important;\n    height: 100% !important;\n    z-index: 0;\n  }\n\n  /*  .header-fixed .header {\n    position: fixed;\n    top: 0;\n    right: 0;\n    left: 0;\n    z-index: 97;\n    height: auto!important;\n    -webkit-transition: all 0.3s ease;\n    transition: all 0.3s ease;\n  } */\n}\n\n.tarjetalogin {\n  width: 35% !important;\n}\n\n.movil {\n  display: inline-block !important;\n}\n\n.movilshow {\n  display: none !important;\n}\n\n@media (max-width: 991.98px) {\n  .header-mobile-fixed .wrapper {\n    padding-top: 0px;\n  }\n\n  .movil {\n    display: none !important;\n  }\n\n  .movilshow {\n    display: block !important;\n  }\n\n  .tarjetalogin {\n    width: 90% !important;\n  }\n\n  /* .header-mobile-fixed .header-mobile {\n  position: fixed;\n  right: 0;\n  bottom: 0;\n  left: 0;\n  z-index: 3000;\n  height: 55px;\n  min-height: 64px;\n} */\n\n  .bg-size {\n    background-size: 75% !important;\n    margin-bottom: 10px;\n  }\n\n  .notifygif {\n    width: 100%;\n    padding-right: 90.5px;\n    padding-left: 90.5px;\n    margin-bottom: 12px;\n  }\n\n  .modal-dialog {\n    max-width: 100% !important;\n    margin-left: 5px;\n    margin-right: 5px;\n  }\n\n  .fijo {\n    position: inherit !important;\n    height: 100% !important;\n    z-index: 0 !important;\n  }\n\n  .fijopanelleft {\n    margin-left: 0 !important;\n  }\n}\n\n/*Acordion estylos personalizados*/\n.card-header-acordion {\n  padding: 0rem 2.25rem;\n  margin-bottom: 0;\n  background-color: #e8f0fe;\n  border-bottom: none;\n  color: black !important;\n  border-radius: none !important;\n}\n\n.card-header:first-child {\n  border-radius: none !important;\n}\n\n.transicioncolor {\n  background-color: #9b59b6;\n  -webkit-transition: font-size 1s ease;\n  transition: font-size 1s ease;\n}\n\n.negrita {\n  font-weight: bold !important;\n}\n\n.card.card-custom > .card-body {\n  padding: 0;\n}\n\n.btn {\n  border-radius: none !important;\n}\n\n.btn-menu-personalizado {\n  display: inline-block;\n  font-weight: normal;\n  color: #3f4254;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.65rem 1rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: none;\n}\n\n.btn {\n  display: inline-block;\n  font-weight: normal;\n  color: #3f4254;\n  text-align: center;\n  vertical-align: middle;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n  background-color: transparent;\n  border: 1px solid transparent;\n  padding: 0.65rem 1rem;\n  font-size: 1rem;\n  line-height: 1.5;\n  border-radius: 0rem;\n  -webkit-transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out,\n    border-color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out,\n    border-color 0.3s ease-in-out, -webkit-box-shadow 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out,\n    border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out;\n  transition: color 0.3s ease-in-out, background-color 0.3s ease-in-out,\n    border-color 0.3s ease-in-out, box-shadow 0.3s ease-in-out,\n    -webkit-box-shadow 0.3s ease-in-out;\n}\n\n/* .header-fixed .wrapper {\n    padding-top: 51px !important;\n  } */\n\n.bordetr {\n  box-shadow: 0px 2px 2px 0px rgb(202 212 228);\n  cursor: pointer;\n}\n\n.bordetr:hover {\n  background-color: #e3e3e3;\n}\n\n.cursor {\n  cursor: pointer !important;\n}\n\n.cursorselect :hover {\n  background-color: #fc4718;\n  color: white;\n}\n\n#btn-0:hover {\n  background-color: #f5f4f4 !important;\n}\n\n#btn-1:hover {\n  background-color: #f5f4f4 !important;\n}\n\n#btn-2:hover {\n  background-color: #f5f4f4 !important;\n}\n\n#btn-3:hover {\n  background-color: #f5f4f4 !important;\n}\n\n#btn-perfil1:hover {\n  background-color: #dc3545 !important;\n}\n\n.container {\n  max-width: 100% !important;\n}\n\n.fijo {\n  position: fixed;\n  height: 100%;\n  background: none;\n}\n\n.titulosSize {\n  font-size: 15px !important;\n  font-weight: bold;\n  color: grey;\n}\n\n.menuitemsize {\n  font-size: 10px !important;\n  font-weight: bold;\n  margin-left: 12px;\n  text-decoration: none;\n  color: black;\n  float: left;\n}\n\n.menu_container .link {\n  padding-left: 20px;\n  /*   border-bottom: #fff 0.5px solid;\n */\n}\n\n.link {\n  display: flex;\n  color: white !important;\n  gap: 10px;\n  padding: 5px 7px;\n  border-right: 4px solid transparent;\n  transition: 0.2s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n.link:hover {\n  border-right: 4px solid #f6dfda;\n  background: #f6dfda;\n  transition: 0.1s cubic-bezier(0.6, -0.28, 0.735, 0.045);\n}\n\n.link:hover > * {\n  color: black;\n  fill: black;\n}\n\n.menu_item {\n  display: flex;\n  gap: 10px;\n}\n\n.menu_container {\n  display: flex;\n  flex-direction: column;\n}\n\n.floatderecha {\n  float: right;\n}\n\n.floatizquierda {\n  float: left;\n}\n\n.initspan {\n  background: none;\n  color: black;\n}\n\n.menuspam {\n  color: #dc3545;\n}\n\n/*=================*/\n.custom-switch.custom-switch-sm .custom-control-label::after {\n  width: calc(1rem - 4px);\n  height: calc(1rem - 4px);\n  border-radius: calc(1rem - (1rem / 2));\n}\n\n.custom-switch.custom-switch-sm\n  .custom-control-input:checked\n  ~ .custom-control-label::after {\n  transform: translateX(calc(1rem - 0.25rem));\n}\n\n/* for md */\n\n.custom-switch.custom-switch-md .custom-control-label {\n  padding-left: 2rem;\n  padding-bottom: 1.5rem;\n}\n\n.custom-switch.custom-switch-md .custom-control-label::before {\n  height: 1.5rem;\n  width: calc(2rem + 0.75rem);\n  border-radius: 3rem;\n}\n\n.custom-switch.custom-switch-md .custom-control-label::after {\n  width: calc(1.5rem - 4px);\n  height: calc(1.5rem - 4px);\n  border-radius: calc(2rem - (1.5rem / 2));\n}\n\n.custom-switch.custom-switch-md\n  .custom-control-input:checked\n  ~ .custom-control-label::after {\n  transform: translateX(calc(1.5rem - 0.25rem));\n}\n\n/* for lg */\n\n.custom-switch.custom-switch-lg .custom-control-label {\n  padding-left: 3rem;\n  padding-bottom: 2rem;\n}\n\n.custom-switch.custom-switch-lg .custom-control-label::before {\n  height: 2rem;\n  width: calc(3rem + 0.75rem);\n  border-radius: 4rem;\n}\n\n.custom-switch.custom-switch-lg .custom-control-label::after {\n  width: calc(2rem - 4px);\n  height: calc(2rem - 4px);\n  border-radius: calc(3rem - (2rem / 2));\n}\n\n.custom-switch.custom-switch-lg\n  .custom-control-input:checked\n  ~ .custom-control-label::after {\n  transform: translateX(calc(2rem - 0.25rem));\n}\n\n/* for xl */\n\n.custom-switch.custom-switch-xl .custom-control-label {\n  padding-left: 4rem;\n  padding-bottom: 2.5rem;\n}\n\n.custom-switch.custom-switch-xl .custom-control-label::before {\n  height: 2.5rem;\n  width: calc(4rem + 0.75rem);\n  border-radius: 5rem;\n}\n\n.custom-switch.custom-switch-xl .custom-control-label::after {\n  width: calc(2.5rem - 4px);\n  height: calc(2.5rem - 4px);\n  border-radius: calc(4rem - (2.5rem / 2));\n}\n\n.custom-switch.custom-switch-xl\n  .custom-control-input:checked\n  ~ .custom-control-label::after {\n  transform: translateX(calc(2.5rem - 0.25rem));\n}\n\n/*STYLOS IMAGENES*/\n.containerImg {\n  position: relative;\n  width: 100%;\n}\n\n.imageImg {\n  opacity: 1;\n  display: block;\n  width: 100%;\n  height: auto;\n  transition: 0.5s ease;\n  backface-visibility: hidden;\n}\n\n.middleImg {\n  transition: 0.5s ease;\n  opacity: 0;\n  position: absolute;\n  top: 50%;\n  left: 50%;\n  right: -41%;\n  transform: translate(-50%, -50%);\n  -ms-transform: translate(-50%, -50%);\n  text-align: center;\n}\n\n.containerImg:hover .imageImg {\n  opacity: 0.3;\n}\n\n.containerImg:hover .middleImg {\n  opacity: 1;\n}\n\n.textImg {\n  background-color: #0446aa;\n  color: white;\n  font-size: 16px;\n  padding: 16px 32px;\n}\n\n.bgfondo {\n  /*   background-color: #f0f2f5;\n */\n  background-color: #1b3765;\n}\n\n.bgfondodark {\n  background-color: #f0f2f5;\n}\n\n.bgfondo3 {\n  background-color: #004aad !important;\n}\n\n.negrita {\n  font-weight: bold;\n}\n\n.bordebottom {\n  border-bottom: 1px solid #f0f2f5 !important;\n}\n\n.bordetop {\n  border-top: 1px solid #f0f2f5;\n}\n\n.textTitleFondo {\n  font-weight: 500;\n}\n\n.badgevet {\n  margin-top: -13px;\n  position: fixed;\n  margin-left: -4px;\n  padding: 6px;\n  width: 23px;\n  background: red;\n  color: white;\n  font-weight: bold;\n  font-size: 14px;\n}\n\n.inputIcon {\n  width: 15%;\n  height: 45px;\n  /*   box-shadow: 0px 0px 1px 1px #00000036; */\n  z-index: 10;\n\n  background: white;\n}\n\n.inputIconText {\n  max-width: 20%;\n  width: 20%;\n  height: 45px;\n  box-shadow: 0px 0px 1px 1px #00000036;\n  z-index: 10;\n}\n\n.inputtext {\n  width: 100%;\n  padding: 12px;\n  text-decoration: none;\n  background: #f5f7fc !important;\n  height: 45px !important;\n  overflow: auto;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n\n  resize: none;\n}\n\n.inputtext2 {\n  width: 100%;\n  padding: 10px;\n  text-decoration: none;\n  background: white !important;\n  height: 45px !important;\n  overflow: auto;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n\n  resize: none;\n}\n\n.inputtext3 {\n  width: 100%;\n  padding: 10px;\n  text-decoration: none;\n  background: white !important;\n  height: 40px !important;\n  overflow: auto;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  border-radius: 5px !important;\n\n  resize: none;\n}\n\n.inputselect {\n  width: 100%;\n  padding: 12px;\n  text-decoration: none;\n  background: #f5f7fc !important;\n  border-radius: 0px;\n  height: 45px !important;\n  overflow: auto;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n\n  resize: none;\n}\n\n.inputselect2 {\n  width: 100%;\n  padding: 12px;\n  text-decoration: none;\n  background: white !important;\n  border-radius: 5px;\n  height: 45px !important;\n  overflow: auto;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n\n  resize: none;\n}\n\n.textareapublicar {\n  width: 100%;\n  padding: 12px;\n  text-decoration: none;\n  background: #f0f2f5 !important;\n  border-radius: 5px;\n  overflow: hidden;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  text-align: justify;\n  text-justify: inter-word;\n  resize: vertical;\n}\n\n.borde-tarjetapublicacion {\n  box-shadow: 0px 3px 8px 1px rgb(169 164 164 / 68%);\n  border: 1px solid #ced4da !important;\n  background-clip: border-box !important;\n}\n\n.selector {\n  /* definir una altura pequeña para forzar el scroll */\n  height: 100px;\n  overflow-y: scroll;\n  width: 400px;\n\n  /* cambiar el estilo por defecto de la barra de scroll */\n  scrollbar-color: black white;\n  scrollbar-width: 25px;\n}\n\ndiv::-webkit-scrollbar {\n  height: 10px;\n  width: 10px;\n}\n\ndiv::-webkit-scrollbar-track {\n  box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);\n}\n\ndiv::-webkit-scrollbar-thumb {\n  background-color: grey;\n  outline: 0px solid white;\n  border-radius: 30px;\n}\n\n@media (min-width: 992px) {\n  .header-fixed .wrapper {\n    padding-top: 60px !important;\n  }\n}\n\n@media (max-width: 425px) {\n  .offcanvas {\n    width: 100% !important;\n  }\n}\n\nlegend {\n  display: block;\n  width: 50% !important;\n  max-width: 100%;\n  min-width: 50%;\n  padding: 8px 6px;\n  margin: 0px !important;\n  margin-bottom: 0.5rem;\n  margin-left: -1px !important;\n  font-size: 1.5rem;\n  line-height: inherit;\n  color: black;\n  font-weight: bold;\n  white-space: normal;\n  background-color: white;\n  margin-top: -10px !important;\n  background-color: #ffff;\n  border: 1px solid #bdc3c7 !important;\n}\n\nfieldset {\n  min-width: 100%;\n  padding: 12px;\n  margin: 0;\n  border-style: double;\n  background-color: #fff;\n  border: 1px solid #bdc3c7 !important;\n}\n\n.bad {\n  position: absolute !important;\n  top: 2px !important;\n  margin-left: 10px;\n  height: 23px;\n  background-color: #2196f3;\n  color: white !important;\n}\n\n.muted > * {\n  color: #b5b5c3;\n}\n\n.badge-danger {\n  color: #ffffff;\n  background-color: red;\n}\n\n.badge-success {\n  color: #ffffff;\n  background-color: green;\n}\n\n.acomodate {\n  width: 230px;\n  white-space: nowrap;\n  text-overflow: ellipsis;\n  overflow: hidden;\n}\n\n.chat_submit_box {\n  bottom: 12px !important;\n  box-sizing: border-box;\n  left: 0;\n  overflow: hidden;\n  padding: 2px;\n  position: absolute;\n  width: 100%;\n  border: 1px solid #ccc;\n  background-color: white;\n}\n\n.borde-tarjeta-login {\n  box-shadow: 3px 7px 15px 1px rgb(21, 19, 19);\n  background-clip: border-box !important;\n}\n\n.toast-error {\n  border: none !important;\n  background-color: rgb(247, 108, 108) !important;\n  text-align: center;\n  margin: 0;\n}\n\n.tituloestilo {\n  font-size: 1.5rem !important;\n}\n\n.tituloestilo:hover {\n  color: #7ac0f7;\n}\n\n.desc {\n  overflow: hidden;\n  font-size: 1rem;\n  line-height: 20px;\n  color: #737373;\n  text-overflow: ellipsis;\n}\n\n.novisto {\n  background-color: #e7e7e7a3 !important;\n}\n\n.visto {\n  background-color: white !important;\n}\n\n.topContainer {\n  display: -webkit-box;\n  flex-direction: row;\n  overflow: auto;\n  max-width: 440px !important;\n  margin-left: 5px;\n  margin-bottom: 12px;\n}\n\n.wraper {\n  flex-wrap: wrap;\n  max-width: 120px;\n  min-width: 120px;\n}\n\n.textoPerfil {\n  font-size: 12px;\n  text-align: left;\n}\n\n.btn-primary-vet {\n  background-color: #004aad !important;\n  border-color: #004aad !important;\n}\n\n.text-btn {\n  font-size: 10px !important;\n}\n\n.borde-botones {\n  box-shadow: 4px 4px 3px 0px rgba(9, 9, 9, 0.35);\n  background-clip: border-box !important;\n}\n\n.bg-btn-vet {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n  border: 1px solid #e4e6eb !important;\n  border-color: #e4e6eb !important;\n  background-color: #e4e6eb !important;\n  color: black !important;\n  font-weight: bold !important;\n}\n\n.bg-btn-small-circle-check {\n  padding: 4px 4px !important;\n  border-radius: 50% !important;\n  border: 1px solid #67ba52 !important;\n  border-color: #67ba52 !important;\n  background-color: #67ba52 !important;\n  color: white !important;\n  font-weight: bold !important;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: center;\n}\n\n.bg-btn-small-circle {\n  padding: 4px 4px !important;\n  border-radius: 50% !important;\n  border: 1px solid #e4e6eb !important;\n  border-color: #e4e6eb !important;\n  background-color: #e4e6eb !important;\n  color: black !important;\n  font-weight: bold !important;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: centerx;\n}\n\n.bg-btn-small-circle-danger {\n  padding: 4px 4px !important;\n  border-radius: 50% !important;\n  border: 1px solid #d70c0c !important;\n  border-color: #d70c0c !important;\n  background-color: #d70c0c !important;\n  color: white !important;\n  font-weight: bold !important;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: centerx;\n}\n.bg-btn-small-circle-white {\n  padding: 4px 4px !important;\n  border-radius: 50% !important;\n  border: 1px solid #ffffff !important;\n  border-color: #ffffff !important;\n  background-color: #ffffff !important;\n  color: black !important;\n  font-weight: bold !important;\n  width: 25px;\n  height: 25px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  align-self: centerx;\n}\n\nh5 {\n  margin: 0 !important;\n}\n\n.bg-btn-vet-opciones {\n  /* padding: 8px 8px !important; */\n  border-radius: 5px !important;\n  border: 1px solid #e4e6eb !important;\n  border-color: #e4e6eb !important;\n  background-color: #e4e6eb !important;\n  color: black !important;\n  font-weight: bold !important;\n  height: 35px !important;\n}\n\n.bg-btn-vet-login {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n\n  color: #f0f2f5 !important;\n  font-weight: bold !important;\n}\n\n.bg-vet-blue {\n  background-color: #004aad !important;\n}\n\n.colorwhite {\n  color: white !important;\n}\n\n.colorblack {\n  color: black !important;\n}\n\n.bg-btn-vet-danger {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n  border: 1px solid #dc3545 !important;\n  border-color: #dc3545 !important;\n  background-color: #dc3545 !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n.bg-btn-vet-warning {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n  border: 1px solid #ffa500 !important;\n  border-color: #ffa500 !important;\n  background-color: #ffa500 !important;\n  color: black !important;\n  font-weight: bold !important;\n}\n\n/* Botón de Ocultar */\n.bg-btn-hide {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n  border: 1px solid #666 !important;\n  border-color: #666 !important;\n  background-color: #666 !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n/* Botón de Publicar */\n.bg-btn-publish {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n  border: 1px solid #00c853 !important;\n  border-color: #00c853 !important;\n  background-color: #00c853 !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n/* Botón de Nuevo */\n.bg-btn-new {\n  padding: 8px 8px !important;\n  border-radius: 5px !important;\n  border: 1px solid #2196f3 !important;\n  border-color: #2196f3 !important;\n  background-color: #2196f3 !important;\n  color: white !important;\n  font-weight: bold !important;\n}\n\n.titulosubmenusize {\n  font-size: 14px !important;\n}\n\n.bg-btn-sm {\n  font-size: 9px !important;\n  padding: 5px !important;\n}\n\n.react-datalist-input__textbox {\n  width: 100%;\n  font-size: 0.875rem;\n  line-height: 1.25rem;\n  margin: 0;\n  border: none !important;\n  background: #ffff !important;\n  height: 40px !important;\n  border-radius: none !important;\n}\n\n.botoneliminar {\n  font-size: 10px;\n}\n\n.bordecompleto {\n  border: 1px solid #ced4da !important;\n}\n\n.bordecompletoerror {\n  border: 3px solid #dc3545 !important;\n}\n\n.bordevertical {\n  border-top: 1px solid #ced4da !important;\n  border-bottom: 1px solid #ced4da !important;\n}\n\n.form-control {\n  border: none !important;\n}\n\n.bgfondo2 {\n  /* background-color: #f0f2f5; */\n  background-color: #f6dfda;\n}\n\n.modal80 {\n  max-width: 80% !important;\n}\n\n.tabla-detalle-factura thead tr {\n  text-align: center;\n  background: #f5f7fc !important;\n}\n\n.tabla-detalle-factura thead tr th {\n  padding: 12px !important;\n}\n\n.tabla-detalle-factura tbody tr {\n  text-align: center;\n  background: #ffff !important;\n}\n\n.tabla-detalle-factura tbody tr td {\n  padding: 8px !important;\n}\n\n.emisor tbody tr td {\n  padding: 3px !important;\n}\n\n.tablares {\n  width: 100%;\n  overflow-x: auto;\n}\n\n.btn-tabla-factura {\n  width: 40px;\n  height: 35px;\n  border: none;\n}\n\n.borderadiusinput {\n  border-radius: 5px;\n}\n\n.bordesuperiorizquierdo {\n  border-top-left-radius: 20px;\n}\n\n.bordeinferiorizquierdo {\n  border-bottom-left-radius: 20px;\n}\n\n.bordesuperiorderecho {\n  border-top-right-radius: 20px;\n}\n\n.bordeinferiorderecho {\n  border-bottom-right-radius: 20px;\n}\n\n.espacioderecho {\n  margin-right: 10px;\n}\n\n.active-descuento {\n  background-color: #004aad;\n  color: white;\n}\n\n.svg2 {\n  width: 100% !important;\n  height: auto !important;\n}\n\n.svgpreloadfactura {\n  width: 150px !important;\n  height: auto !important;\n}\n\n.tabalconmenu {\n  position: relative;\n  width: 100%;\n  border-radius: inherit;\n  overflow-x: inherit !important;\n  overflow-y: inherit !important;\n  min-height: 0;\n  max-height: 300px;\n  -webkit-overflow-scrolling: touch;\n}\n\n.scrollx {\n  overflow-x: scroll;\n}\n\n.scrollauto {\n  overflow-x: auto;\n}\n\n.scrollin {\n  overflow-x: inherit;\n}\n\n/* .ddmenu{\n  margin-left: -120px!important;\n  position :inherit!important\n} */\n\n/*.\nsc-dmRaPn\niXRfeU */\n\n.bordederecho {\n  border-right: 1px solid #ced4da !important;\n}\n\n.bordeizquierdo {\n  border-left: 1px solid #ced4da !important;\n}\n\n.bordearriba {\n  border-top: 1px solid #ced4da !important;\n}\n\n.bordeabajo {\n  border-bottom: 1px solid #ced4da !important;\n}\n\n.bordevertical {\n  border-left: none !important;\n  border-right: none !important;\n  border-bottom: 1px solid #ced4da !important;\n  border-top: 1px solid #ced4da !important;\n}\n\n.bordehorizontal {\n  border-bottom: none !important;\n  border-top: none !important;\n  border-left: 1px solid #ced4da !important;\n  border-right: 1px solid #ced4da !important;\n}\n\n.dropoculto {\n  display: none !important;\n}\n\n.textmenu {\n  font-size: 13px !important;\n  font-weight: 750 !important;\n}\n\n.infoadicional {\n  width: 100%;\n  padding: 25px;\n  text-decoration: none;\n  background: #fdfdfd !important;\n  border-radius: 5px;\n  overflow: hidden;\n  border: none;\n  outline: none;\n  -webkit-box-shadow: none;\n  -moz-box-shadow: none;\n  box-shadow: none;\n  text-align: justify;\n  text-justify: inter-word;\n  resize: vertical;\n}\n\n.btn-mediano {\n  width: 120px !important;\n}\n\n.bg-green {\n  background-color: rgb(37, 164, 37);\n  color: white;\n}\n\n.listadocumentos {\n  height: 50px;\n  width: 33.3%;\n  background-color: white;\n  color: black;\n  font-size: 12px;\n  font-weight: bold;\n  border: none;\n}\n\n.listadocumentos:hover {\n  background-color: #fc4718;\n  color: white;\n}\n\n.documentoactivo {\n  background-color: #243c54;\n  color: white;\n}\n\n.scrollx {\n  overflow-x: scroll;\n}\n\n.accordion-body {\n  padding: 0;\n}\n\n.imanav {\n  height: 50px;\n  width: 50px;\n}\n\n.w-70 {\n  width: 70%;\n}\n\n.w-30 {\n  width: 30%;\n}\n\n@media (max-width: 662px) {\n  .w-70 {\n    width: 0%;\n  }\n\n  .w-30 {\n    width: 100%;\n    margin: 12px;\n  }\n}\n\n.modal-backdrop.show {\n  opacity: 0.8;\n  background-color: white;\n}\n\n.bordesombreado {\n  box-shadow: 1px 2px 3px 0px rgb(141 143 147);\n  background-clip: border-box !important;\n  /* box-shadow: 0 0 7px 0px rgb(187, 188, 191); */\n}\n\n.toast-message-error {\n  background: red;\n  color: #fff;\n  font-size: 20px;\n  padding: 12px 12px;\n  margin: 12px;\n  width: 100%;\n  fill: white;\n}\n\n.toast-message-error svg {\n  fill: white;\n}\n\nlabel {\n  padding: 0px;\n}\n\n.titulomenutabla {\n  width: 9px !important;\n}\n\n.size16 {\n  font-size: 16px !important;\n}\n\n.size17 {\n  font-size: 17px !important;\n}\n\n.size18 {\n  font-size: 18px !important;\n}\n\nbutton > *:hover {\n  cursor: pointer;\n}\n\n.accordion-button:not(.collapsed) {\n  color: white;\n  background-color: #243c54;\n  box-shadow: inset 0 -1px 0 rgba(0, 0, 0, 0.125);\n}\n\n.accordion-button:focus {\n  z-index: 3;\n  border-color: #eff1f5;\n  outline: 0;\n  box-shadow: 0 0 0 0.25rem rgb(255 255 255 / 25%);\n}\n\n.viewer {\n  background-color: #e4e4e4;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  height: 800px;\n  overflow-y: auto;\n  margin-bottom: 10px;\n}\n\n.azulmarino {\n  background-color: #243c54 !important;\n}\n\n.azulindigo {\n  background-color: #00416a;\n}\n.text-white {\n  color: white;\n}\n\n.color-azulmarino {\n  color: #243c54 !important;\n}\n\n.naranja {\n  background-color: #fc4718 !important;\n}\n\n.color-naranja {\n  color: #fc4718 !important;\n}\n\n.plomo {\n  background-color: #dcd3d4 !important;\n}\n\n.color-plomo {\n  color: #dcd3d4 !important;\n}\n\n.color-blanco {\n  color: #ffff !important;\n}\n\n.borderradiusnone {\n  border-radius: 0 !important;\n}\n\n.iconmenu {\n  font-size: 16px !important;\n}\n\n.hovernaranja:hover {\n  background-color: #fc4718 !important;\n  color: white !important;\n}\n\n.card-custom {\n  overflow: hidden;\n  min-height: 300px;\n  box-shadow: 0 0 5px rgba(10, 10, 10, 0.3);\n  border: 1px solid rgb(64, 59, 59);\n}\n\n.card-custom-2 {\n  overflow: hidden;\n  width: 100%;\n  min-height: 10px;\n  box-shadow: 0 0 5px rgba(10, 10, 10, 0.3);\n  border: 1px solid rgb(3, 2, 2);\n}\n\n.borde-tarjeta-derecho {\n  box-shadow: 0px 0px 7px rgb(200, 193, 193);\n  background-clip: border-box !important;\n  /* box-shadow: 0 0 7px 0px rgb(187, 188, 191); */\n}\n\n.objetocircular {\n  border-radius: 50%;\n}\n\n.proyectoN {\n  background-color: #02426a68;\n}\n\n.proyecto {\n  background-color: #d20d0d;\n}\n\n.desactivar {\n  background-color: #ffbfbf !important ;\n}\n\n.backimage {\n  background-image: url(\"https: //upload.wikimedia.org/wikipedia/commons/thumb/2/2f/Link_at_Igromir_2012.jpg/320px-Link_at_Igromir_2012.jpg\");\n}\n\n.uploadbanner:hover {\n  opacity: 0.6;\n}\n.uploadbanner {\n  opacity: 0;\n}\n.fondocolor {\n  background-color: #f6dfda;\n}\n\n.fondocolorBlue {\n  background-color: #1b3765;\n}\n\n.letrablanca {\n  color: white;\n}\n\n/* grupos de acceso */\n\n.collage-badge {\n  background-color: #47637a;\n  color: white;\n  padding: 5px 10px;\n  border-radius: 10px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  margin-bottom: 5px;\n}\n\n.react-select__value-container {\n  overflow-y: auto !important;\n  max-height: 80px;\n}\n\n.text-table-sm {\n  padding: 0.4375rem 0.625rem;\n  font-size: 0.875rem;\n}\n\n.mantine-DatePickerInput-input {\n  border-radius: 5px !important;\n  height: 45px;\n  width: 100%;\n  max-width: 100%;\n}\n\n.mantine-DatePickerInput-wrapper {\n  border-radius: 5px !important;\n  width: 100%;\n  max-width: 100%;\n}\n\n.mantine-InputWrapper-root {\n  border-radius: 5px !important;\n  width: 100%;\n  max-width: 100%;\n}\n\n#proxy-renderer {\n  overflow: hidden;\n  display: flex;\n  justify-content: center;\n}\n\n#no-renderer {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  padding: 20px;\n}\n\n#no-renderer-download {\n  width: 250px;\n}\n\n#pdf-controls {\n  z-index: 100;\n}\n\n.scrollable-div::-webkit-scrollbar {\n  width: 5px;\n}\n\n.scrollable-div::-webkit-scrollbar-track {\n  background: #ddd;\n  border-radius: 0 2px 2px 0;\n}\n\n.scrollable-div::-webkit-scrollbar-thumb {\n  background: #666;\n  border-radius: 0 2px 2px 0;\n}\n\n.scrollable-div::-webkit-scrollbar-thumb:hover {\n  background: #555;\n}\n\n.input-user-code div input {\n  font-size: 4rem;\n  margin-top: 7px;\n  height: 80px;\n}\n\n\n.button-keyboard-numeric-animation {\n  transition: all 0.1s;\n}\n\n.button-keyboard-numeric-animation:active {\n  transform: scale(1.3);\n  background-color: #1b3765;\n}\n\n.button-acept-animation {\n  transition: all 0.2s;\n}\n\n.button-acept-animation:active {\n  transform: scale(1.3);\n  background-color: #0c803c;\n}\n\n.btnconfirmar{\n  height: 150px!important;\n}\n\n*{\n  font-family: \"Source Sans 3\", system-ui, -apple-system, \"Segoe UI\", Roboto, \"Helvetica Neue\", \"Noto Sans\", \"Liberation Sans\", Arial, sans-serif, \"Apple Color Emoji\", \"Segoe UI Emoji\", \"Segoe UI Symbol\", \"Noto Color Emoji\";\n    font-size: 14px;\n}\n\n\n.small-box .small-box-icon {\n  position: absolute;\n  top: 15px;\n  right: 15px;\n  z-index: 0;\n  height: 70px;\n  font-size: 70px;\n  color: rgba(0, 0, 0, 0.15);\n  transition: transform 0.3s linear;\n}   \n\n.small-box {\n  border-radius: 0.375rem;\n  box-shadow: 0 0 1px rgba(var(--bs-body-color-rgb), 0.125), 0 1px 3px rgba(var(--bs-body-color-rgb), 0.2);\n  position: relative;\n  display: block;\n  margin-bottom: 1.25rem;\n  --bs-link-color-rgb: none;\n  --bs-link-hover-color-rgb: none;\n  --bs-heading-color: none;\n}\n\n.small-box > * {\n  color:white\n}\n\n\n.td-consolidado{\n  border-bottom: 1px solid rgba(71, 70, 70, 0.25);\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
